package com.zaurh.portfolio.data.repository

import com.zaurh.portfolio.data.ContactDTO
import com.zaurh.portfolio.data.request.ContactRequest
import com.zaurh.portfolio.domain.repository.ContactRepository
import com.zaurh.portfolio.utils.Constants.WEBFORM_ACCESS_KEY
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

class ContactRepositoryImpl(
    private val client: HttpClient
) : ContactRepository {

    override suspend fun sendContactMessage(
        name: String,
        email: String,
        subject: String,
        message: String
    ): Boolean {
        val response = client.post("https://api.web3forms.com/submit") {
            contentType(ContentType.Application.Json)

            setBody(
                ContactRequest(
                    access_key = WEBFORM_ACCESS_KEY,
                    name = name,
                    email = email,
                    subject = subject,
                    message = message
                )
            )
        }

        return response.body<ContactDTO>().success
    }
}